// extracted by mini-css-extract-plugin
export default {"container":"S02_container__IYrJZ","limiter":"S02_limiter__cmcXI"};